'use strict';

angular.module('internal.services')
    .controller('InternalUserServicesLongevity', ['$scope', '$stateParams', '$q', 'ServiceUserLongevities', 'Services', '$state', function ($scope, $stateParams, $q, ServiceUserLongevities, Services, $state) {
        $scope.resetUser();
        $scope.longevity = $stateParams.longevity;
        $scope.longevityID = $stateParams.longevityID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        var promises = [];

        promises.push(Services.get({ user_id: $scope.userID, inactiveServiceUsers: true, longevityGet: true }).then(function (user_services) {
            $scope.user_services = user_services;
            $scope.loading = false;
        }))

        if ($stateParams.longevityID != null) {
            promises.push(ServiceUserLongevities.getByID($stateParams.longevityID).then(function (longevity) {
                $scope.longevity = longevity;
                $scope.longevity.credit_awarded_date = $scope.longevity.awarded_date || new Date();
            }))
        }
        else {
            $scope.longevity = { user_id: $scope.userID, credit_awarded_date: new Date() };
        }

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.save = function () {
            $scope.saving = true;

            ServiceUserLongevities.save($scope.longevity).then(function () {
                $scope.saving = false;
                $state.go('internal.licensing.user.services.longevities', { id: $scope.userID });
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this service longevity credit?')) {
                ServiceUserLongevities.delete($scope.longevityID).then(function () {
                    $scope.deleting = false;
                    $state.go('internal.licensing.user.services.longevities', { id: $scope.userID });
                })
            }
            else {
                $scope.deleting = false;
            }
        }
    }])
;